import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const QuotationContext = createContext();

// Custom hook to use the quotation context
export const useQuotation = () => {
  const context = useContext(QuotationContext);
  if (!context) {
    throw new Error('useQuotation must be used within a QuotationProvider');
  }
  return context;
};

// Load from localStorage
const loadFromLocalStorage = () => {
  const stored = localStorage.getItem('quotationProducts');
  return stored ? JSON.parse(stored) : [];
};

// Provider component
export const QuotationProvider = ({ children }) => {
  const [quotationProducts, setQuotationProducts] = useState(loadFromLocalStorage);

  // Save to localStorage whenever quotationProducts changes
  useEffect(() => {
    localStorage.setItem('quotationProducts', JSON.stringify(quotationProducts));
  }, [quotationProducts]);

  const addToQuotation = (product) => {
    setQuotationProducts((prev) => [...prev, product]);
  };

  const removeFromQuotation = (productId) => {
    setQuotationProducts((prev) => prev.filter((product) => product.id !== productId));
  };

  const updateQuantity = (id, quantity) => {
    setQuotationProducts((prev) =>
      prev.map((product) =>
        product.id === id ? { ...product, quantity } : product
      )
    );
  };

  const clearQuotation = () => {
    setQuotationProducts([]);
    localStorage.removeItem('quotationProducts');
  };

  const value = {
    quotationProducts,
    addToQuotation,
    removeFromQuotation,
    updateQuantity,
    clearQuotation,
  };

  return (
    <QuotationContext.Provider value={value}>
      {children}
    </QuotationContext.Provider>
  );
};
